import { analytics } from '../../../store/analyticStore/constants/analytics';

export const sendButtonEvent = (name: string | undefined) => {
  analytics.track('Button', {
    Button: name,
    Location: window.location.pathname,
  });
};
